
import React, {FC} from 'react';
interface IType {
    isActive?: boolean
}

export const NotificationIcon: FC<IType> = ({isActive}) => {
    return (
    <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.9991 0C10.1299 0 9.42763 0.698242 9.42763 1.5625V2.5C5.84281 3.22266 3.14192 6.37695 3.14192 10.1562V11.0742C3.14192 13.3691 2.29236 15.5859 0.760221 17.3047L0.396828 17.71C-0.0156721 18.1689 -0.113886 18.8281 0.13656 19.3896C0.387006 19.9512 0.951739 20.3125 1.57049 20.3125H20.4276C21.0464 20.3125 21.6062 19.9512 21.8616 19.3896C22.1169 18.8281 22.0138 18.1689 21.6013 17.71L21.2379 17.3047C19.7058 15.5859 18.8562 13.374 18.8562 11.0742V10.1562C18.8562 6.37695 16.1553 3.22266 12.5705 2.5V1.5625C12.5705 0.698242 11.8683 0 10.9991 0ZM13.2236 24.0869C13.8129 23.501 14.1419 22.7051 14.1419 21.875H10.9991H7.8562C7.8562 22.7051 8.18522 23.501 8.77451 24.0869C9.36379 24.6729 10.1642 25 10.9991 25C11.8339 25 12.6343 24.6729 13.2236 24.0869Z"/>
    </svg>
);
};

